import React,{useState} from 'react'
import TabElement from './TabElement';
import TabBody from './TabBody';
import ClinicInfo from './ClinicInfo';
import Hours from './Hours';
import RecallHours from './RecallHours';
import OpticalInfo from './OpticalInfo';
import ReputationInfo from './ReputationInfo';
import ClinicUser from './ClinicUser';
function TabCard() {
    const [activeTab, setActiveTab] = useState('general');
    const handleTabClick = (tab) => {
      setActiveTab(tab);
    };
  return (
    <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-4">
                                <TabElement 
                                    name="general"
                                    title="General"
                                    subtitle="Clinic general settings."
                                    activename={activeTab}
                                    handleclick={handleTabClick}
                                />
                                <TabElement 
                                    name="hours"
                                    title="Hours"
                                    subtitle="Clinic regular hours."
                                    activename={activeTab}
                                    handleclick={handleTabClick}

                                />
                                 <TabElement 
                                    name="recall-hours"
                                    title="Recall Hours"
                                    subtitle="Recall sending hours."
                                    activename={activeTab}
                                    handleclick={handleTabClick}
                                />
                              
                                 <TabElement 
                                    name="optical-lab"
                                    title="Optical Lab"
                                    subtitle="Settings for Optical Lab."
                                    activename={activeTab}
                                    handleclick={handleTabClick}
                                />
                               
                              

                                <TabElement 
                                    name="users"
                                    title="Users"
                                    subtitle="Eyeconx users"
                                    activename={activeTab}
                                    handleclick={handleTabClick}
                                />
                        </div>
                        <div className="col-8">
                            {/* Tab Body */}
                            <TabBody name="general" activename={activeTab}>
                                   <ClinicInfo/>
                            </TabBody>
                            <TabBody name="hours" activename={activeTab}>
                                <Hours/>
                            </TabBody>
                            <TabBody name="recall-hours" activename={activeTab}>
                                <RecallHours/>
                            </TabBody>
                            <TabBody name="optical-lab" activename={activeTab}>
                                <OpticalInfo/>
                            </TabBody>
                            <TabBody name="reputation" activename={activeTab}>
                                <ReputationInfo/>
                            </TabBody>
                            <TabBody name="users" activename={activeTab}>
                                <ClinicUser/>
                            </TabBody>

                        </div>
                    </div>
                </div>
            </div>
  )
}

export default TabCard